import React, { Component } from 'react';
import "../../assets/css/login.css"
import { withRouter } from "react-router";
// Connect react and redux
import { connect } from 'react-redux';
// Action call from redux
import { loginNews } from '../../redux/actions/NewsAction';
import { getPortalSettings, getloginUrl } from '../../redux/actions/UserActions';
// Language translate import
import { withTranslation } from 'react-i18next';
//Moment
import moment from 'moment'
import Loading from '../Loader/Loader';
import ErrorPage from '../Error/ErrorPage';
import { errorToast } from '../Notification/Notification';
import { dateTimeFormat } from '../../config/ApiConfig';

class Login extends Component {
    constructor(props) {
        super(props)

        this.state = {
            vippsLoginURL: "",
            bankidLoginURL: "",
            news: [],
            ellipsText: 72,
            appLogo: "",
            loginText: "",
            buttonText: "",
            homePageUrl: "https://www.avantit.no/advokat",
            companyName: "",
            vatNo: ""
        }
    }
    componentDidMount() {
        localStorage.clear();
        this.props.getloginUrl();
        this.props.getPortalSettings();
        this.props.loginNews();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.loginUrl !== this.props.loginUrl && Object.keys(this.props.loginUrl).length > 0) {
            const loginUrlData = this.props.loginUrl.Result;
            this.setState({
                bankidLoginURL: loginUrlData.bankIdLoginUrl,
                vippsLoginURL: loginUrlData.vippsLoginUrl
            });
        }
    
        if (prevProps.portalSettings !== this.props.portalSettings && Object.keys(this.props.portalSettings).length > 0) {
            const data = this.props.portalSettings;
            let loginTitle = "";
            let loginText;
            try {
                loginText = JSON.parse(data.Result.portalMessageConfig.loginPageConfiguration);
            } catch (e) {
                loginTitle = data.Result.portalMessageConfig.loginPageConfiguration;
            }
    
            if (loginText && loginText.length > 0) {
                const titleText = loginText.find(item => item.titleText)?.titleText || "";
                const buttonText = loginText.find(item => item.buttonText)?.buttonText || "";
                const homePageUrl = loginText.find(item => item.homePageUrl)?.homePageUrl || "";
                const companyName = loginText.find(item => item.companyName)?.companyName || "";
                const vatNo = loginText.find(item => item.vatNo)?.vatNo || "";
                this.setState({
                    titleText,
                    buttonText,
                    homePageUrl,
                    companyName,
                    vatNo
                });
            } else {
                loginTitle = data.Result.portalMessageConfig.loginPageConfiguration;
            }
            if (loginTitle) {
                this.setState({
                    loginText: loginTitle,
                    appLogo:localStorage.getItem("publicportallogo")
                });
            }
            this.setState({
                appLogo:localStorage.getItem("publicportallogo")
            });
            localStorage.setItem('dashBoardMessage', `${data.Result.portalMessageConfig.dashboardMessage}`);
            localStorage.setItem('bookingMessage', `${data.Result.portalMessageConfig.bookingMessage}`);
            localStorage.setItem('unauthorisedErrorMessage', `${data.Result.portalMessageConfig.unauthorisedErrorMessage}`);
            localStorage.setItem('portalTermsUrl', `${data.Result.portalMessageConfig.portalTermsUrl}`);
            localStorage.setItem('bookingConfirmation', `${data.Result.portalMessageConfig.bookingConfirmation}`);
        }
    
        if (prevProps.loginnews !== this.props.loginnews && Object.keys(this.props.loginnews).length > 0) {
            const newsData = this.props.loginnews;
            if (newsData.Success) {
                this.setState({
                    news: newsData.Result.TopNews
                });
            } else {
                errorToast(newsData.Message);
            }
        }
    }

    render() {
        if (this.props.error) {
            return <ErrorPage />;
        }
        return (
            <div className={"login-window-" + window.globalConfig.CustomerName} id="loginPage" >
                {this.props.loginUrlfetching && <Loading />}
                <div className="login-area rounded">
                    <div className="login-column">
                    {this.state.appLogo?<p><img src={this.state.appLogo} /></p>:""}
                        <div className="login-ftr">
                            <h3>{this.state.loginText == "" ? this.props.t('login.portalMessage') : this.state.loginText}</h3>
                        </div>
                        <div className="login-ftr mt-5">
                            <p>{this.state.buttonText ? this.state.buttonText : this.props.t('login.message')} </p>
                            <a className="vippsbtn mb-4" href={`${this.state.vippsLoginURL}`}>
                                <svg fill="none" height="44" viewBox="0 0 250 44" width="250" xmlns="http://www.w3.org/2000/svg"><path d="m0 8c0-2.80026 0-4.20039.544967-5.26995.479363-.94081 1.244273-1.70572 2.185083-2.185083 1.06956-.544967 2.46969-.544967 5.26995-.544967h234c2.8 0 4.2 0 5.27.544967.941.479363 1.706 1.244273 2.185 2.185083.545 1.06956.545 2.46969.545 5.26995v28c0 2.8003 0 4.2004-.545 5.27-.479.9408-1.244 1.7057-2.185 2.185-1.07.545-2.47.545-5.27.545h-234c-2.80026 0-4.20039 0-5.26995-.545-.94081-.4793-1.70572-1.2442-2.185083-2.185-.544967-1.0696-.544967-2.4697-.544967-5.27z" fill="#ff5b24" /><g fill="#fff"><path d="m40.2401 26.2537h-5.9799v-11.0386h-2.3306v13.0349h8.3105zm5.8884 2.195c2.9539 0 4.7515-1.9331 4.7515-5.1399 0-3.1887-1.8067-5.1218-4.7515-5.1218-2.9358 0-4.7515 1.9422-4.7515 5.1218 0 3.2068 1.7886 5.1399 4.7515 5.1399zm0-1.8337c-1.5627 0-2.457-1.2105-2.457-3.2971 0-2.0867.8943-3.2971 2.457-3.2971 1.5537 0 2.448 1.2104 2.448 3.2971 0 2.0866-.8852 3.2971-2.448 3.2971zm11.0554 5.3928c2.8816 0 4.7063-1.4363 4.7063-3.7036v-9.9275h-2.159v1.5808h-.1535c-.542-1.0749-1.7163-1.7434-3.0623-1.7434-2.5202 0-4.083 1.9692-4.083 4.9954 0 2.9629 1.5537 4.896 4.0469 4.896 1.373 0 2.448-.5782 3.0171-1.6441h.1536v1.8789c0 1.2556-.8943 1.9964-2.43 1.9964-1.2285 0-2.0234-.4427-2.168-1.1382h-2.2492c.1806 1.6982 1.8428 2.8093 4.3811 2.8093zm0-5.6819c-1.5628 0-2.448-1.2104-2.448-3.1255 0-1.906.8852-3.1164 2.448-3.1164 1.5537 0 2.5022 1.2104 2.5022 3.1255 0 1.906-.9395 3.1164-2.5022 3.1164zm11.507 5.6819c2.8816 0 4.7063-1.4363 4.7063-3.7036v-9.9275h-2.1589v1.5808h-.1536c-.542-1.0749-1.7163-1.7434-3.0622-1.7434-2.5203 0-4.083 1.9692-4.083 4.9954 0 2.9629 1.5537 4.896 4.0468 4.896 1.3731 0 2.448-.5782 3.0171-1.6441h.1536v1.8789c0 1.2556-.8943 1.9964-2.4299 1.9964-1.2286 0-2.0235-.4427-2.168-1.1382h-2.2493c.1807 1.6982 1.8428 2.8093 4.3811 2.8093zm0-5.6819c-1.5627 0-2.448-1.2104-2.448-3.1255 0-1.906.8853-3.1164 2.448-3.1164 1.5537 0 2.5022 1.2104 2.5022 3.1255 0 1.906-.9394 3.1164-2.5022 3.1164zm13.1318-9.6023c.7407 0 1.3459-.5871 1.3459-1.3278 0-.7317-.6052-1.3279-1.3459-1.3279-.7317 0-1.337.5962-1.337 1.3279 0 .7407.6053 1.3278 1.337 1.3278zm-1.1111 11.5264h2.2312v-9.8733h-2.2312zm4.8134 0h2.2402v-5.7542c0-1.4814.8401-2.4118 2.177-2.4118 1.364 0 1.9964.7678 1.9964 2.3035v5.8625h2.2402v-6.3865c0-2.3486-1.2014-3.6765-3.4055-3.6765-1.4724 0-2.4661.6685-2.9358 1.7705h-.1536v-1.5808h-2.1589zm11.1096 0h2.2402v-5.7542c0-1.4814.8401-2.4118 2.1772-2.4118 1.364 0 1.996.7678 1.996 2.3035v5.8625h2.24v-6.3865c0-2.3486-1.201-3.6765-3.405-3.6765-1.473 0-2.4662.6685-2.9359 1.7705h-.1536v-1.5808h-2.1589zm15.8414 0h2.24v-6.0071c0-1.2285.823-2.1589 1.934-2.1589 1.102 0 1.788.6684 1.788 1.7615v6.4045h2.177v-6.1697c0-1.1291.768-1.9963 1.933-1.9963 1.202 0 1.807.6413 1.807 1.9241v6.2419h2.231v-6.793c0-2.0505-1.192-3.27-3.171-3.27-1.373 0-2.511.7046-2.999 1.7796h-.153c-.416-1.0931-1.364-1.7796-2.728-1.7796-1.31 0-2.322.6685-2.746 1.7796h-.154v-1.5899h-2.159zm23.007-2.7009c-.326.7407-1.093 1.1562-2.205 1.1562-1.472 0-2.42-1.0478-2.475-2.719v-.1174h6.902v-.7136c0-3.0984-1.689-4.9683-4.508-4.9683-2.863 0-4.643 1.9963-4.643 5.167 0 3.1616 1.753 5.0947 4.661 5.0947 2.331 0 3.984-1.1201 4.39-2.8996zm-2.295-5.6187c1.346 0 2.231.9485 2.277 2.448h-4.653c.1-1.4814 1.039-2.448 2.376-2.448zm10.143 8.4822c1.373 0 2.511-.6414 3.071-1.7253h.154v1.5627h2.168v-13.6943h-2.24v5.3928h-.154c-.524-1.084-1.644-1.7344-2.999-1.7344-2.493 0-4.065 1.9692-4.065 5.0947 0 3.1346 1.563 5.1038 4.065 5.1038zm.696-8.3286c1.535 0 2.484 1.2375 2.484 3.2339 0 2.0053-.94 3.2339-2.484 3.2339-1.536 0-2.466-1.2105-2.466-3.2339 0-2.0144.939-3.2339 2.466-3.2339z" /><path clipRule="evenodd" d="m219.75 20.0884c-.72-2.7477-2.469-3.8384-4.855-3.8384-1.934 0-4.361 1.0907-4.361 3.7172 0 1.6968 1.173 3.0304 3.085 3.374l1.811.323c1.234.2221 1.584.6869 1.584 1.3132 0 .7071-.761 1.111-1.893 1.111-1.481 0-2.406-.5252-2.551-2.0001l-2.612.4042c.411 2.8483 2.962 4.0204 5.266 4.0204 2.181 0 4.505-1.2528 4.505-3.778 0-1.7174-1.049-2.9696-3.003-3.3337l-1.996-.3633c-1.111-.202-1.481-.7475-1.481-1.2727 0-.6668.72-1.0907 1.708-1.0907 1.255 0 2.139.4239 2.18 1.8179zm-58.075 4.3229 2.715-7.8584h3.188l-4.731 11.6565h-2.366l-4.731-11.6563h3.188zm16.683-4.5249c0 .9292-.74 1.5756-1.604 1.5756s-1.605-.6464-1.605-1.5756c0-.9294.741-1.5756 1.605-1.5756s1.605.6462 1.605 1.5756zm.494 4.1213c-1.07 1.3734-2.201 2.3229-4.197 2.323-2.036 0-3.62-1.2121-4.854-2.9897-.494-.7275-1.255-.889-1.811-.5051-.514.3637-.637 1.1314-.164 1.7982 1.707 2.5656 4.073 4.0602 6.829 4.0602 2.531 0 4.506-1.2119 6.048-3.2322.576-.7473.556-1.515 0-1.9393-.514-.4044-1.275-.2624-1.851.4849zm7.098-1.6568c0 2.384 1.399 3.6367 2.962 3.6367 1.481 0 3.004-1.1719 3.004-3.6367 0-2.4244-1.523-3.5959-2.983-3.5959-1.584 0-2.983 1.1111-2.983 3.5959zm0-4.1815v-1.5964h-2.9v15.677h2.9v-5.576c.967 1.2932 2.222 1.8389 3.641 1.8389 2.654 0 5.246-2.0608 5.246-6.3031 0-4.061-2.695-5.9596-4.999-5.9596-1.831 0-3.086.8281-3.888 1.9192zm13.928 4.1815c0 2.384 1.398 3.6367 2.962 3.6367 1.481 0 3.003-1.1719 3.003-3.6367 0-2.4244-1.522-3.5959-2.983-3.5959-1.584 0-2.983 1.1111-2.983 3.5959zm0-4.1815v-1.5964h-.001-2.9v15.677h2.9v-5.576c.967 1.2932 2.222 1.8389 3.641 1.8389 2.654 0 5.246-2.0608 5.246-6.3031 0-4.061-2.695-5.9596-4.999-5.9596-1.831 0-3.085.8281-3.887 1.9192z" fillRule="evenodd" /></g></svg>
                            </a>
                            {this.state.bankidLoginURL &&
                                <a className="loginbankid" href={`${this.state.bankidLoginURL}`}>
                                    Login with BankID
                                </a>
                            }
                            <p className="fnt-14">   <a className="vippsbtn mt-2 d-block" href={this.state.homePageUrl}>
                                {this.props.t('login.backLink')} </a></p>
                            <div style={{ display: "flex", justifyContent: "center" }} >
                                <p style={{ fontSize: "8px" }}>{this.state.companyName}</p>
                                <p style={{ fontSize: "8px", marginLeft: "5px" }}>{this.state.vatNo}</p>
                            </div>
                        </div>
                    </div>
                    {window.globalConfig.CustomerName !== "Kreftforeningen" && window.globalConfig.CustomerName !== "Osloadvokatene" && window.globalConfig.CustomerName !== "Rettssenteret" &&
                        <div className="news-column">
                            <h3 className="mb-3 mt-0">{this.props.t('login.newsTitle')}</h3>
                            <ul className="newslist">
                                {
                                    this.state.news.map((key, i) => (
                                        <a key={i} href={key.Hyperlink} target="_blank">
                                            <li key={i}>
                                                <img src={key.Image} alt="News" />
                                                <p className="mb-1">
                                                    {(key.Description !== null && key.Description !== undefined && (key.Description).length > this.state.ellipsText) ?
                                                        (((key.Description).substring(0, this.state.ellipsText - 3)) + '...') :
                                                        key.Description}
                                                </p>
                                                <p className="date mb-0">{moment(key.PublishFromDate).format(dateTimeFormat.dateOnlyFormat)}</p>
                                            </li>
                                        </a>
                                    ))
                                }
                            </ul>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    loginUrlfetching: state.user.fetching,
    loginUrl: state.user.loginUrl,
    portalSettings: state.user.portalSettings,
    loginnews: state.news.loginNews,
    error: state.error.isError
})

const mapDispatchToProps = {
    getloginUrl,
    getPortalSettings,
    loginNews
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(Login)));